// This base class ensures that all registered web components get registered as known widgets
export class WidgetElement extends HTMLElement {
  constructor() {
    super()

    WidgetElement.widgets.add(this.tagName.toLowerCase())
  }

  static widgets = new Set()
}
